//* 可视化图形
import type { GeneticInformationOptions } from '@cya/genetic-information';

export interface LayoutProps {
    type: string;
    name: string;
    symbol: string;
    strand: string;
    labels: { name: string; data: string }[];
    version: string;
    species: number;
    nicknames: string[];
    descript: { default: string; origin: string };
    mutations: { benign: number; uncertain: number; pathogenic: number; benign_likely: number; pathogenic_likely: number };
    related_ids: { id: string; name: string; href: string }[];

    info: {
        exon: number;
        ncbi: string;
        size: string;
        mutations: number;
        references: number;
        transcripts: number;
        related_models: { id: string; name: string }[];
        related_diseases: number;
        molecular_weight: string;
    };

    chromosome: GeneticInformationOptions["data"]["chromosome"];
    attachments: GeneticInformationOptions["data"]["attachments"];
}

export const PropsOption = {
    origin: { type: Object as PropType<LayoutProps>, required: true },
} as const;

export type DefaultPropsTypes = ExtractPropTypes<typeof PropsOption>;
